module.exports = __webpack_public_path__ + "static/img/7.73578de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/7.png
// module id = ojSW
// module chunks = 0